import { useEffect, useRef, useState } from 'react'

const auto_grow = (element) => {
  element.style.height = element.scrollHeight + 'px'
}

const ChatInput = ({ send }) => {
  const [showSub, setShowSub] = useState(false)
  const inputRef = useRef(null)

  const enableSub = () => {
    setShowSub(true)
  }

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter' || event.keyCode === 13) {
        event.preventDefault()
        if(inputRef.current.value.trim() !== ''){
          send(inputRef.current.value)
          inputRef.current.value = ''
          event.target.style.height = '5px'
          event.target.style.height = event.target.scrollHeight + 'px'
        }
      }
    }
    document.addEventListener('keydown', listener)
    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [send])

  return (
    <div className="sticky bottom-0 backdrop-blur-lg bg-bg/20 pb-4">
      <textarea
        ref={inputRef}
        onInput={(e) => auto_grow(e.target)}
        onFocus={enableSub}
        placeholder="Type your message here"
        className="resize-none overflow-hidden h-[56px] placeholder:text-primary/[0.40] w-full border rounded-md p-4 border-primary/20 active:border-primary/50 focus:border-primary/50 focus:outline-none text-dark/70"
      />
      {showSub && <p className="text-xs text-primary">Press return to send</p>}
    </div>
  )
}

export default ChatInput
